// extracted by mini-css-extract-plugin
export default {"login":"Login_login__galMv","background":"Login_background__XaE80","logo":"Login_logo__N9IYP","languages":"Login_languages__BQCRa"};